import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import CaseStatusIcons from "components/CaseStatusIcons";

const IconsCell: FC<Props> = ({ element, statuses, onMetric }) => {
  return (
    <div className={styles.icons}>
      <CaseStatusIcons
        Case={element}
        inList={true}
        searchText={null}
        showStatus={false}
        keepIconPlace={true}
        showGotoCase={true}
        statuses={statuses}
        onMetric={onMetric}
      />
    </div>
  );
};

export default IconsCell;
